import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import React from 'react'

import styles from './LoadingIndicator.module.sass'

const LoadingIndicator = (props) => {
	const { className, label, ...attributes } = props
	const { i18n } = useGlobal()
	return (
		<div
			className={`${styles['loading-indicator']} ${className || ''}`}
			{...attributes}
		>
			<div>
				<Icon className={styles['action-icon']} name='on-going' />
				<small>{label ?? i18n`Loading`}</small>
			</div>
		</div>
	)
}

export default LoadingIndicator
